import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";
import { EmptyState } from "@/components/DataTable";
import { PageHead } from "@/components/Filters";
import { api, errMsg } from "@/lib/api";

export default function SavedSearches() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    try {
      const { data } = await api.get("/saved-searches");
      setItems(data);
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    load();
  }, []);

  const remove = async (id) => {
    await api.delete(`/saved-searches/${id}`);
    setItems((p) => p.filter((i) => i.id !== id));
    toast.success("Removed");
  };

  return (
    <div className="space-y-4" data-testid="saved-searches-page">
      <PageHead title="Saved Searches" subtitle="Re-apply a filter combination you use often." />
      {loading ? (
        <div className="border border-slate-200 bg-white p-10 text-center text-sm text-slate-400">Loading…</div>
      ) : items.length === 0 ? (
        <EmptyState testId="saved-empty" title="No saved searches" hint="Use “Save search” on any module to store the current filters here." />
      ) : (
        <div className="divide-y divide-slate-100 border border-slate-200 bg-white" data-testid="saved-list">
          {items.map((s) => (
            <div key={s.id} className="flex items-start justify-between gap-4 p-4">
              <div>
                <p className="font-display text-base font-semibold text-slate-900">{s.name}</p>
                <p className="mt-0.5 text-[11px] font-semibold uppercase tracking-widest text-slate-400">{s.module}</p>
                <p className="mt-2 font-mono-num text-xs text-slate-600">
                  {Object.entries(s.params)
                    .filter(([, v]) => v)
                    .map(([k, v]) => `${k}=${v}`)
                    .join("  ·  ") || "no filters"}
                </p>
              </div>
              <button
                data-testid={`delete-saved-${s.id}`}
                onClick={() => remove(s.id)}
                className="text-slate-400 hover:text-rose-600"
              >
                <Trash2 className="h-4 w-4" />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
